import { Type } from 'class-transformer';
import { SORespProject } from '../project/so-resp-project';
import { SORespOrganization } from '../organization/so-resp-organization';
import {ObjectiveProtocol} from 'lionheartland';
import {Backlog} from "../../dexie/db";

export class SORespBacklog implements ObjectiveProtocol {

  entityType: string = 'backlog';
  uid: string;
  name: string;
  description: string = "";
  @Type(() => SORespProject)
  project: SORespProject;
  @Type(() => SORespOrganization)
  organization: SORespOrganization;

    toBacklog(): Backlog {
        return {
            uid: this.uid,
            name: this.name,
            description: this.description,
            dateCreated: null,
            worksUid: null,
            projectUid: this.project ? this.project.uid : null,
            organizationUid: this.organization ? this.organization.uid : null,
}

        };
}